import {
  milestoneVar
} from './variables';

export const localMilestone = () => {
  return milestoneVar();
}